/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ResponseUserWeeklyScheduleExceptionDto } from '../../models/response-user-weekly-schedule-exception-dto';
import { UpdateUserWeeklyScheduleExceptionDto } from '../../models/update-user-weekly-schedule-exception-dto';

export interface UserWeeklyScheduleExceptionsControllerUpdate$Params {

/**
 * Tenant identifier
 */
  tenant: string;

/**
 * User email
 */
  email: string;

/**
 * Creation timestamp of the exception
 */
  createdAt: string;
      body: UpdateUserWeeklyScheduleExceptionDto
}

export function userWeeklyScheduleExceptionsControllerUpdate(http: HttpClient, rootUrl: string, params: UserWeeklyScheduleExceptionsControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseUserWeeklyScheduleExceptionDto>> {
  const rb = new RequestBuilder(rootUrl, userWeeklyScheduleExceptionsControllerUpdate.PATH, 'patch');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('email', params.email, {});
    rb.path('createdAt', params.createdAt, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ResponseUserWeeklyScheduleExceptionDto>;
    })
  );
}

userWeeklyScheduleExceptionsControllerUpdate.PATH = '/thalea-google-events/user-weekly-schedule-exceptions/{tenant}/{email}/{createdAt}';
